import React, { Component } from 'react';
import { connect } from 'react-redux';
import ParkingSpotInfoHeader from './../../components/MapInfoBar/ParkingSpotInfoHeader';
import ParkingSpotInfoDetail from './../../components/MapInfoBar/ParkingSpotInfoDetail';
import ParkingSpotInfoFooter from './ParkingSpotInfoFooter/';
import ParkingSpotInfoDetailMobile from './ParkingSpotInfoDetailMobile';
import { checkUserLoggedIn } from './../../utils';

class ParkingSpotInfo extends Component {

  infoBarClassByStatus(spotDetails) {
    const {isFilteredByMe, currentState} = spotDetails;
    const { attendees = [] } = currentState;
    const { isBlockedSpot, isReservedByMe, attendee } = this.props;
    const spotHolderMatch = attendees.length ? isReservedByMe && (attendees[0].uidAttendee === attendee.uidAttendee) : false;

    if(isBlockedSpot) {
      return "spot__unavailable";
    } else if (spotHolderMatch) {
      return "spot__mine";
    } else if (isFilteredByMe) {
      return "spot__filtered";
    } else if (currentState.status === "OPEN") {
      return "spot__available";
    }
    return "spot__unavailable";
  }

  parkingSpotDetails(attendees) {
    const {isMobileDevice} = this.props;
    return isMobileDevice ? <ParkingSpotInfoDetailMobile attendees={attendees}  /> : <ParkingSpotInfoDetail attendees={attendees}  />;
  }

  render() {
    const { spotId, hasQualifiedSpots, spotInfoDetailedView, isBlockedSpot,
      spotDetails, isReadOnly, ispreBooked, isUserLoggedIn, isMobileDevice, isReservedByMe, attendee } = this.props;

    const { currentState, properties } = spotDetails;
    const { attendees = [], status } = currentState;
    const { location, size, surface, amenities } = properties;
    const spotHolderMatch = attendees.length ? isReservedByMe && (attendees[0].uidAttendee === attendee.uidAttendee) : false;
    let className = `map-infobar__spot ${this.infoBarClassByStatus(spotDetails)} `;

    if(isMobileDevice) {
      className += spotInfoDetailedView ? 'opened' : '';
    }

    return (
      <div className={className}>
        <ParkingSpotInfoHeader
          amenities={amenities}
          spotId={spotId}
          location={location}
          size={size}
          surface={surface}
        />
        { this.parkingSpotDetails(attendees) }
        {
          !isBlockedSpot && (
            <ParkingSpotInfoFooter
              spotId={spotId}
              spotDetails={spotDetails}
              isReservedByMe={spotHolderMatch}
              hasQualifiedSpots={hasQualifiedSpots}
              status={status}
              isReadOnly={isReadOnly}
              ispreBooked={ispreBooked}
              isUserLoggedIn={isUserLoggedIn}
              isMobileDevice={isMobileDevice}
              attendee={attendee}
            />)
        }
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const { reservedSpots, qualifiedSpots, attendee } = state.userAccommodationInfo;
  const { spotInfoDetailedView } = state.navOptions;
  const { user } = state;
  const { blockedSpotsList, preBookedSpotsList } = state.session;
  const isBlockedSpot = blockedSpotsList.includes(ownProps.spotId);
  const ispreBooked = preBookedSpotsList.includes(ownProps.spotId);
  const isUserLoggedIn = checkUserLoggedIn(user);
  const isReservedByMe = isUserLoggedIn ? reservedSpots.includes(ownProps.spotId) : false;

  return {
    reservedSpots,
    spotInfoDetailedView,
    isBlockedSpot,
    ispreBooked,
    isReservedByMe,
    isUserLoggedIn,
    hasQualifiedSpots: qualifiedSpots > 0,
    isMobileDevice: state.browser.lessThan.medium,
    attendee
  };
};

export default connect(mapStateToProps)(ParkingSpotInfo);



// WEBPACK FOOTER //
// ./src/containers/MapInfoBar/ParkingSpotInfo.js